export const CAMPAIGN_TYPES = ['Promotion', 'Brand', 'Theme'] as const;
export const TASK_STATUSES = ['Not started', 'In progress', 'Done'] as const;
export const BRAND_PRIORITIES = ['A', 'B', 'C'] as const;
